import {
  call, put, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import downloadHelper from '@/utils/downloads';
import { downloadDatasetDictionariesError } from '../actions';
import actions from '../constants';
import DictionariesService from '../service';

export function* download({ code }) {
  const { response, error } = yield call(callAdapter, DictionariesService.dictionaries(code, 1, null));
  if (error) {
    yield put(downloadDatasetDictionariesError(code, error));
  } else {
    downloadHelper.jsonDownload(response.items, `${code}_dictionaries.json`);
  }
}

export default function* dictionariesApi() {
  yield takeEvery(actions.DOWNLOAD_DICTIONARIES, download);
}
